import { createFileRoute } from '@tanstack/react-router';
import { tiktokStaticData } from '../tiktok';

export const Route = createFileRoute('/_private-routes/tiktok/campaigns')({
  staticData: tiktokStaticData
});
